import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=3635f81f&scoped=true&"
import script from "./iconList.ts?vue&type=script&lang=ts&"
export * from "./iconList.ts?vue&type=script&lang=ts&"
import style0 from "./IconList.vue?vue&type=style&index=0&id=3635f81f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635f81f",
  null
  
)

export default component.exports